module.exports = __webpack_public_path__ + "static/media/sword.42d06bf0.png";